import { mapGetPropGetters, createGetPropGetter } from '@/store/utils';
import { userRoleGroups } from '@/constants/auth';

export default {
  ...mapGetPropGetters(['auth', 'profile', 'permissions']),
  userId(state) {
    return state.auth ? state.auth.sub : null;
  },
  profile: createGetPropGetter('profile', null),
  loginDomain: createGetPropGetter('loginDomain', {}),
  userPoolId: createGetPropGetter('userPoolId', {}),
  userInitials(state, { profile }) {
    return profile ? `${profile.firstName.substr(0, 1)}${profile.lastName.substr(0, 1)}` : '';
  },
  userEmail(state, { profile }) {
    return profile ? profile.email : '';
  },
  userRoleGroup(state, { permissions }) {
    if (permissions) {
      return permissions.includes('company.customer') ? userRoleGroups.CISO : userRoleGroups.SP;
    }
    return '';
  },
  authChallenge(state) {
    const { challengeName, challengeUser } = state;
    return challengeName && challengeUser ? { challengeName, challengeUser } : {};
  },
  prefillData: createGetPropGetter('prefillData', null),
};
